import './styles_root.scss'
//import './element-variables.scss'
import 'element-plus/dist/index.css'

import { createApp } from 'vue'

import App from './App.vue'

import ElementPlus from 'element-plus'
import { ElLoading } from 'element-plus'

import { createI18n } from 'vue-i18n'


import router from './router'

const app = createApp(App).use(router)

const i18n = createI18n({
    legacy: false
})

app.use(ElLoading)

app.config.globalProperties.window = window

app.use(ElementPlus)
app.use(i18n)
app.mount('#app')

